import { RootState } from 'store';

export const chatSelector = (state: RootState) => state.chat;
export const chatLoadingSelector = (state: RootState) => state.chat.loading;
export const chatConversationsSelector = (state: RootState) => state.chat.conversations;
export const chatSelectedConversationSelector = (state: RootState) => state.chat.selectedConversation;
export const chatSelectedConversationMessagesSelector = (state: RootState) => state.chat.selectedConversationMessages;
export const chatConnectionStateSelector = (state: RootState) => state.chat.connectionState;
